import tableConfig from '@/views/pages/tableConfig'

export default function config(moduleName, arg = {}) {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'apply_doc', label: 'Full name', sortable: true },
    { key: 'score', label: 'Score', sortable: true },
    { key: 'apply_doc.dc_type', label: 'Dc Type', sortable: true },
    { key: 'comment', label: 'Comment', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'actions', label: '' },
  ]

  return {
    tableColumns,
    ...tableConfig(moduleName, arg),
  }
}
